import React, { useContext, useEffect, Fragment } from 'react';
import AuthContext from '../../Context/autenticacion/authContext';
import StocksAdmin from './StocksAdmin';
import StocksSeller from './StocksSeller';
import AlertNotAuthorized from '../../Complements/AlertNotAuthorized';
import StocksSubAdmin from './StocksSubAdmin';

export default function StockIndex() {
   //Extraer la informacion de autenticación
   const authContext = useContext(AuthContext);
   const { usuario, usuarioAutenticado } = authContext;

   useEffect(() => {
    usuarioAutenticado();
  }, []);

  let component;
  if(usuario){
    switch (usuario.type) {
		case '1':
			component = <StocksAdmin />
			break;
		case '2': 
			component = <StocksSeller />
      break;
    case '3': 
			component = <StocksSubAdmin />
			break;
		  default:
			component = <AlertNotAuthorized mensaje={"No tienes los suficientes permisos para ver esta página"}/>
			break;
    }
  }
  return (
    <Fragment>
      {component}
    </Fragment>
  )
}
